package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.util.modifier.borderExceptBottom
import com.wintermar.inspection.feature.presentation.inspection.answer.InspectionAnswerState
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.complete_inspection
import inspection.composeapp.generated.resources.next_page
import inspection.composeapp.generated.resources.previous_page
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

@Composable
fun Footer(
    state: InspectionAnswerState,
    listState: LazyListState,
    scope: CoroutineScope,
    paddingValues: PaddingValues,
    fillWidth: Float,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Column(
        modifier = Modifier
            .fillMaxWidth(fillWidth)
            .background(
                color = color.surface.normal
            )
            .borderExceptBottom(
                color = color.border.subtle,
                topLeftRadius = dimension.radius.md,
                topRightRadius = dimension.radius.md
            )
            .padding(bottom = paddingValues.calculateBottomPadding())
    ) {
        if (fillWidth == 1f) HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = color.border.subtle
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    horizontal = dimension.spacing.space4,
                    vertical = dimension.spacing.space3
                ),
            horizontalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space4,
                alignment = Alignment.End
            ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (!state.showPrevButton && fillWidth == 1f) {
                Spacer(modifier = Modifier.weight(1f))
            }

            if (state.showPrevButton) {
                Button(
                    buttonVariant = ButtonVariant.MediumOutline,
                    text = stringResource(Res.string.previous_page),
                    modifier = if (fillWidth != 1f) Modifier else Modifier.weight(fillWidth),
                    onClick = {
                        state.onPrevPage()
                        scope.launch {
                            listState.animateScrollToItem(0)
                        }
                    }
                )
            }

            if (state.showNextButton) {
                Button(
                    buttonVariant = ButtonVariant.MediumPrimary,
                    disabled = !state.showNextButton,
                    text = stringResource(Res.string.next_page),
                    modifier = if (fillWidth != 1f) Modifier else Modifier.weight(fillWidth),
                    onClick = {
                        state.onNextPage()
                        scope.launch {
                            listState.animateScrollToItem(0)
                        }
                    }
                )
            }

            if (state.showCompleteButton) {
                Button(
                    buttonVariant = ButtonVariant.MediumPrimary,
                    text = stringResource(Res.string.complete_inspection),
                    modifier = if (fillWidth != 1f) Modifier else Modifier.weight(1f),
                    onClick = {
                        state.onComplete()
                    }
                )
            }
        }
    }
}
